import React from "react";
import { createStyles } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import { Body, Label } from "../../../../components/Typography";
import { BreakdownTable } from "./BreakdownTable";
import { OrderDetailCard, CardSection } from "./OrderDetailCard";
import { PaymentLink } from "./PaymentLink";
import { formatOrderDate, getPaymentStatusDisplayName, isOrderPaid, type Order } from "./shared";

const useStyles = createStyles(() => ({
  paymentMethod: {
    color: tokens.color.primitive.light.gray[700],
  },
}));

const SANDBOX_PAYMENT_MESSAGE = "There are no payments for test orders in the sandbox.";

export const PaymentCard: React.FC<{ order: Order; isSandbox: boolean }> = ({ order, isSandbox }) => {
  const { classes } = useStyles();
  const statusName = getPaymentStatusDisplayName(order.paymentStatus);
  const paid = isOrderPaid(order);

  if (isSandbox) {
    return (
      <OrderDetailCard>
        <CardSection>
          <Label>Payment Status</Label>
          <Body>{SANDBOX_PAYMENT_MESSAGE}</Body>
        </CardSection>
      </OrderDetailCard>
    );
  }

  return (
    <OrderDetailCard>
      <CardSection>
        <Label>Payment Status</Label>
        <Body>
          {statusName}
          {paid && order.salePayment?.createdAt && <> on {formatOrderDate(order.salePayment.createdAt)}</>}
          {paid && order.salePayment?.id != null && <PaymentLink paymentId={order.salePayment.id} />}
        </Body>
        {paid && order.salePayment?.paymentMethodLabel && (
          <Body className={classes.paymentMethod}>via {order.salePayment.paymentMethodLabel}</Body>
        )}
      </CardSection>

      {paid && order.pricing && (
        <BreakdownTable
          data={{
            currency: order.pricing.currency,
            itemsTotal: order.pricing.itemsTotal,
            shippingTotal: order.pricing.shippingTotal,
            taxesTotal: order.pricing.taxesTotal,
            total: order.pricing.orderTotal,
          }}
          sectionLabel="Total Order Amount"
          totalLabel="Order Total"
        />
      )}
    </OrderDetailCard>
  );
};
